<template>
  <div class="header-wrap">
    <div class="lesson-info">
      <span>第{{ lessonNum }}讲</span>
      <a-divider type="vertical" />
      <span>{{ lessonName }}</span>
    </div>

    <div class="middle">
      <slot name="end-tip" />
      <!-- 结束按钮 -->
      <slot name="end-btn" />
    </div>

    <div class="right">
      <!-- 解锁按钮 -->
      <slot name="undo-btn" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiveInstructionHeader',
  data() {
    return {
      lessonNum: '',
      lessonName: ''
    }
  },

  created() {
    const { lessonName, lessonNum	} = this.$route.query
    this.lessonName = lessonName
    this.lessonNum = lessonNum
  }
}
</script>

<style scoped lang="less">
.header-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  height: 52px;
  background: #FFFFFF;
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16);
  position: relative;
  .lesson-info {
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.04em;
    color: #303858;
  }
  .right {
    color: #98A2B2;
  }
}
</style>
